import type { FeatureFlagScope } from '@/state/useFeatureFlags';
import { useState } from 'react';
import { Input } from '@/components/ui/input';
import { ConfirmDialog } from '@/components/Dialogs';

const slugify = (text: string) =>
  text
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

type CreateBranchModalProps = {
  open: boolean;
  scope: FeatureFlagScope;
  flagName: string;
  onConfirm: (branch: string) => Promise<void>;
  onCancel: () => void;
};

export const CreateBranchModal = ({ open, scope, flagName, onConfirm, onCancel }: CreateBranchModalProps) => {
  const [branchSlug, setBranchSlug] = useState(slugify(flagName));
  const [isSubmitting, setIsSubmitting] = useState(false);

  const prefix = `feature/${scope}/`;
  const fullBranch = `${prefix}${branchSlug}`;

  const handleConfirm = async () => {
    setIsSubmitting(true);
    await onConfirm(fullBranch);
    setIsSubmitting(false);
  };

  return (
    <ConfirmDialog
      open={open}
      title="Create Feature Branch"
      confirmLabel="Create Branch"
      disabled={!branchSlug.trim() || isSubmitting}
      onConfirm={handleConfirm}
      onCancel={onCancel}
    >
      <div className="space-y-1.5">
        <label htmlFor="feature-branch-slug" className="micro-label block">
          Branch Name
        </label>
        <div className="flex items-center gap-0">
          <span className="num text-dim border-line bg-panel2 flex h-10 items-center rounded-l-lg border px-3">
            {prefix}
          </span>
          <Input
            id="feature-branch-slug"
            value={branchSlug}
            onChange={(ev) => setBranchSlug(slugify(ev.target.value))}
            className="border-line bg-field text-foreground h-10 rounded-l-none rounded-r-lg border-l-0 text-body"
            autoFocus
          />
        </div>
      </div>
    </ConfirmDialog>
  );
};
